import * as Yup from 'yup'

export const errorModalSchema = Yup.object().shape({
  phone: Yup.string().min(15, 'Telefone inválido').required(),
})
